import React, { useState,useEffect } from 'react';
import {VictoryChart,VictoryAxis,VictoryScatter,VictoryLine} from 'victory';
import ClickableGraph from '../components/ClickableGraph';
import axios from 'axios';
import Api from "../Api/Api.json";
import SidebarNav from './SidebarNav';
import MathPage from './MathPage';
import { useNavigate } from 'react-router-dom';

const SubjectChoicePage = () => {
    const [mediumButton, setMediumButton] = useState(0);
    const [classButton, setClassButton] = useState(0);
    const [subjectButton, setSubjectButton] = useState(0);

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    const [chapter, setChapter] = useState('1');
    const [section, setSection] = useState(1);
    const [problemNo, setProblemNo] = useState(1);
    const [problemListLength, setProblemListLength] = useState(1);
    const [problems, setProblems] = useState({});
    const [currentProblem, setCurrentProblem] = useState({});
    const navigate=useNavigate();
    const mediumList=['bengali'];
    const subjectList=['math'];
    const classList=['6'];

    const loadClass = () => {
        const selectedClass = classList[classButton];
        const selectedMedium = mediumList[mediumButton];
        const selectedSubject = subjectList[subjectButton];
        // Navigate to MathPage with the selected class, medium, and subject
        navigate(`/landing/math-page?level=${selectedClass}&subject=${selectedSubject}&medium=${selectedMedium}`); // Query Params
    };
    const toggleSidebar = () => {
        setIsSidebarVisible(!isSidebarVisible);
      };
    return(
        <div style={{'padding':'15px'}}>
                <div
      style={{
        display: "flex", // Use Flexbox for horizontal stacking
        flexDirection: "row", // Stack children horizontally (default)
        justifyContent: "space-between", // Space between children
        alignItems: "center",
        gap: "10px", // Space between children
        padding: "10px", // Padding around the container
        backgroundColor: "#f4f4f4", // Background color
      }}
    > <h2>ক্লাস নির্বাচন করুন</h2>
    <button onClick={toggleSidebar}>মেনু</button>
    </div>
    <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
    <p> ক্লাস রিপোর্ট দেখতে অনুশীলন ও রিপোর্ট দেখার সময় অবশ্যই লগইন করুন।</p>
    </div>
        <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        শ্রেণী: 
        {Array.from({ length: classList.length }, (_, i) => (
          <button
            key={i}
            onClick={() => setClassButton(i)}
            style={{
              padding: "10px",
              backgroundColor: subjectButton === i ? "blue" : "gray",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {classList[i]}
          </button>
        ))}
      </div>
      <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
      বিষয়: 
        {Array.from({ length: subjectList.length }, (_, i) => (
          <button
            key={i}
            onClick={() => setSubjectButton(i)}
            style={{
              padding: "10px",
              backgroundColor: subjectButton === i ? "blue" : "gray",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {subjectList[i]}
          </button>
        ))}
      </div>

        <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        মাধ্যম: 
        {Array.from({ length: mediumList.length }, (_, i) => (
          <button
            key={i}
            onClick={() => setMediumButton(i)}
            style={{
              padding: "10px",
              backgroundColor: mediumButton === i ? "blue" : "gray",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {mediumList[i]}
          </button>
        ))}
      </div>


      <div>
        <button onClick={loadClass}>
        ক্লাসে যান
        </button></div>
        {isSidebarVisible && <SidebarNav />}
      </div>
    );
};

export default SubjectChoicePage;